export { default } from './ModulInformacio';
